import { Link } from "react-router-dom"
import HomeLayout from "../../commonComponents/HomeLayout"

const DataConsentForm = () => {
    return (
        <HomeLayout>
            <section className="items-center px-8 sm:px-10 lg:px-[174px] pt-[30px] mx-auto max-w-[1300px]">
                <h2 className="h2 text-center">Home and Abroad Data Consent Form</h2>
                <p className="body-description mt-8 text-justify">
                    At Home and Abroad, your privacy is important to us. In line with the Nigerian Data Protection Act
                    (NDPA) and applicable international standards, we seek your informed consent to collect, store,
                    process, and share your data as part of your engagement with our platform.
                </p>
                <br />
                <div className="body-description">
                    <p>
                        <strong>1. Personal Information to be Collected:</strong> <br />
                        We may collect the following categories of personal data
                    </p>
                    <ul className="pl-10 list-disc space-y-2 mt-3">
                        <li>
                            Full Name
                        </li>
                        <li>
                            Contact Information (Phone Number, Email, Address)
                        </li>
                        <li>
                            Identification Documents (e.g Passport, National ID)
                        </li>
                        <li>
                            Financial Information (e.g Bank Details for Transactions)
                        </li>
                        <li>
                            Employment or Immigration Status (if applicable)
                        </li>
                        <li>
                            Property Preference and Transaction Details
                        </li>
                    </ul>
                    <br />
                    <p>
                        <strong>2. Purpose of Data Collection:</strong> <br />
                        Your data will be used for the following purposes:
                    </p>
                    <ul className="pl-10 list-disc space-y-2 mt-3">
                        <li>To verify your identity and facilitate account creation</li>
                        <li>To process real estate transactions securely</li>
                        <li>To liaise with financial institutions (e.g.Banks, Microfinance Banks, Fintech Companies)</li>
                        <li>To issue letters of comfort and place liens (where applicable)</li>
                        <li>To improve our services and communication with you</li>
                        <li>To comply with regulatory obligations</li>
                    </ul>
                    <br />
                    <p>
                        <strong>3. Data Sharing and Disclosure:</strong> <br />
                        Your data may be shared with:
                    </p>
                    <ul className="pl-10 list-disc space-y-2 mt-3">
                        <li>
                            Partner banks and Fintech Companies for transaction security
                        </li>
                        <li>
                            Accredited real estate developers listed on our platform
                        </li>
                        <li>
                            Government agencies, when legally required
                        </li>
                        <li>
                            Third-party service providers for KYC, legal, and IT support
                        </li>
                    </ul>
                    <p className="mt-8">
                        <strong>4. Data Storage and Protection </strong> <br />
                        Your data will be stored securely using industry-standard encryption and access controls. Data will
                        only be retained for as long as necessary to fulfill the purposes stated above or as required by law.
                    </p>
                    <p className="mt-8">
                        <strong>5. Your Rights</strong> <br /> You have the right to:
                    </p>
                    <ul className="list-disc pl-10 space-y-2 mt-3">
                        <li>
                            Access your personal data
                        </li>
                        <li>Correct or update your data</li>
                        <li> Withdraw your consent at any time
                        </li>
                        <li> Request deletion of your data (where legally permissible)
                        </li>
                        <li> Lodge complaints with relevant data protection authorities</li>
                    </ul>
                    <br />
                    <br />
                    <p>
                        <strong>6. Consent Declaration</strong> <br />
                        By agreeing to the terms in this consent form, you confirm that:
                    </p>
                    <ul className="list-disc pl-10 space-y-2 mt-3">
                        <li>You have read and understood this Data Consent Form</li>
                        <li>
                            You have read and understood the <Link to="/privacy-policy" className="text-primary hover:opacity-75">Data Privacy Policy</Link> on our website (Link to the Data
                            Privacy Policy)
                        </li>
                        <li>
                            You consent to the collection, use, and sharing of your personal data as described
                        </li>
                        <li> You are aware that you can withdraw your consent at any time by contacting us at:
                            <br /> <span>Email: <a
                            href="mailto:support@homeandabroad.ng"
                            className="text-primary ml-3 hover:opacity-75"
                        >
                            support@homeandabroad.ng
                        </a>
                        </span>
                            <br /> <span>Phone:<a
                      href="tel:+2347055910000"
                      className="text-primary hover:opacity-75 ml-3"
                    >
                      +234 705 591 0000
                    </a></span></li>
                    </ul>
                </div>
            </section>
        </HomeLayout>
    )
}

export default DataConsentForm